import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import IconButton from '@mui/material/IconButton';
import CustomDialogSmall from "../../../../../components/Dialog/DiaCompSmall";
import DataPickerOLd from "../../../../../components/DatePicker/DatePickerOld";


export default function DiaBook() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
    <Grid container sx={{ justifyContent:'center'}}>
        <IconButton onClick={handleOpen} size="small"  >
            <ContactPhoneIcon sx={{color: 'primary.dark', fontSize: '230%', '&:hover': { color: 'primary.dark'}, }}/>
        </IconButton>   
    </Grid>
    

    <CustomDialogSmall open={open} onClose={handleClose}

          title="Book a genetic counselling session"
          content=<DatePickerOld />

          
        />

      </>
    );
  }